import { CSSProperties } from 'react';

type BackgroundColorProps = {
  color?: CSSProperties['color'];
  size?: number;
};

const BackgroundColor = ({ color, size }: BackgroundColorProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
    >
      <path
        fill="#6D6D82"
        d="M4.14633 4.21798C4.44135 3.92734 4.9184 3.92734 5.21342 4.21798L8.01922 7.01187L9.86151 5.1774C10.7434 4.29923 12.1746 4.29923 13.0565 5.1774L17.8082 9.90888C18.6901 10.7871 18.6901 12.2121 17.8082 13.0903L11.8325 19.0437C10.6556 20.2156 8.74735 20.2156 7.57042 19.0437L3.8827 15.3716C2.70577 14.1997 2.70577 12.2996 3.8827 11.1277L6.95214 8.07129L4.14633 5.28053C3.85445 4.98677 3.85445 4.51174 4.14633 4.21798ZM10.1722 11.2808L8.01608 9.13384L4.94978 12.1902C4.72067 12.4184 4.57944 12.7028 4.52923 12.9997H15.7713L16.7442 12.0309C17.0392 11.7371 17.0392 11.2621 16.7442 10.9714L11.9925 6.23683C11.6975 5.94306 11.2205 5.94306 10.9286 6.23683L9.08631 8.07129L11.2393 10.2183C11.5343 10.512 11.5343 10.9871 11.2393 11.2777C10.9443 11.5683 10.4672 11.5715 10.1754 11.2777L10.1722 11.2808ZM18.9914 20C17.8835 20 16.9827 19.1031 16.9827 17.9999C16.9827 17.2124 18.0059 15.5123 18.5896 14.6029C18.778 14.3091 19.2016 14.3091 19.39 14.6029C19.9769 15.5123 21 17.2124 21 17.9999C21 19.1031 20.0993 20 18.9914 20Z"
      ></path>
      <rect x="3" y="21" width="16" height="2" fill={color}></rect>
    </svg>
  );
};

export default BackgroundColor;
